<template>
    <div class="wrapper">
            <section class="login-content">
                <div class="container">
                    <div class="row align-items-center justify-content-center height-self-center">
                        <div class="col-lg-8">
                            <div class="card auth-card">
                                <div class="card-body p-0">
                                    <div class="d-flex align-items-center auth-content">
                                        <div class="col-lg-7 align-self-center">
                                            <div class="p-3">
                                                <h2 class="mb-2">Changer votre mot de passe</h2>
                                                <p></p>
                                                
                                                <form method="POST" @submit.prevent="submitChangePassword" data-toggle="validator">
                                                    <input type="hidden" name="_token" value="nBuH0FQdqrCkDAhCnRuyOUm4EHU1RNc9jTQ4mawT">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <div class="floating-label form-group">
                                                                <input class="floating-input form-control" type="password" placeholder=" "
                                                                     v-model="user.password" required>
                                                                <label>Mot de passe <span class="text-danger">*</span></label>
                                                            </div>
                                                        </div> <br>
                                                        <div class="col-lg-6">
                                                            <div class="floating-label form-group">
                                                                <input class="floating-input form-control" id="name"
                                                                     v-model="user.newPassword" type="password" placeholder=" "
                                                                    required>
                                                                <label>Nouveau mot de passe<span class="text-danger">*</span></label>
                                                            </div>
                                                        </div> <br>
                                                        <div class="col-lg-6">
                                                            <div class="floating-label form-group">
                                                                <input class="floating-input form-control" type="password"
                                                                    name="last_name" placeholder=" "
                                                                    v-model="user.newPassword_confirmation" required>
                                                                <label>Confirmation <span class="text-danger">*</span></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="isLoading" id="preloader">
                                                        <div class="spinner"></div>
                                                    </div>
                                                    <button type="submit" class="btn btn-primary"> Enregistrer</button>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 content-right">
                                            <img src="/assets/images/yele.gif" class="img-fluid image-right" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="vld-parent">
            <loading :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="fullPage"></loading>
         </div>
        </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
import Loading from 'vue-loading-overlay';
// Import stylesheet
   import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
//import $ from "jquery"
import moment from 'moment'
moment.locale('fr')

export default {
    components: {
            Loading
    },
    data() {
        return {
            user: {},
            isLoading:false
        };
    },
    mounted(){
       
        this.getUsers()
    },
    methods:{
        submitChangePassword(){
            let app = this
            app.isLoading = true
            axios.post(URL_API+'verif-token/'+this.$route.params.token+'/'+this.$route.params.email,this.user)
            .then(function (reponse){
                app.isLoading = false
                console.log(reponse);
                if (reponse.data.status == true) {
                    Swal.fire('Succès',reponse.data.message,'success')
                    setTimeout(() => {
                        app.$router.push('/')
                    }, 2000)
                }else{
                    console.log(typeof reponse.data.message)
                    if (typeof reponse.data.message === 'object') {
                        let err = Object.values(reponse.data.message)
                        console.log(err)
                        Swal.fire('Attention',err[0][0],'warning')
                    }else{
                        Swal.fire('Attention',reponse.data.message,'warning')
                    }
                    
                }
            })
            .catch(function (error){
                app.isLoading = false
                console.log(error);
            })
            
        },
        getUsers(){
            let app = this
            axios.get(URL_API+'verif-token/'+this.$route.params.token+'/'+this.$route.params.email)
            .then(function (reponse){
                console.log('ddsds',reponse);
                if (reponse.data.status == false) {
                    Swal.fire('Attention',reponse.data.message,'warning')
                     setTimeout(() => {
                        app.$router.push('/')
                    }, 2000)
                }
            })
            .then(function (error){
                console.log(error);
            })
        },
    }
}
</script>